import { wsClient, WsRecvType, IWsHandler } from '../client'
import { IClientData } from '../../api/clients'

export enum CustomerState {
    Connected = 0,
    Disconnected = 1,
}

type ICustomerTrafficData = {
    client: IClientData
    state: CustomerState
    revision?: number
}

type ICustomerTrafficHandler = IWsHandler<ICustomerTrafficData>

type ICustomerTrafficCallback = (client: IClientData, state: CustomerState, revision?: number) => void

export type IListenerUID = number

const listeners_: Array<{ id: IListenerUID; callback: ICustomerTrafficCallback }> = []
let listenerInc_ = 0

export function CustomerTrafficHandler() {
    wsClient.submitHandler(WsRecvType.CustomerTraffic, (({ data }) => {
        console.log(
            `%c[WsClient][${new Date().toISOString()}] CustomerTraffic`,
            'color: orange',
            CustomerState[data!.state],
            data!.client,
            'rev=',
            data!.revision,
        )
        for (const listener of listeners_) {
            listener.callback(data!.client, data!.state, data!.revision)
        }
    }) as ICustomerTrafficHandler)
}

export function onCustomerConnect(callback: ICustomerTrafficCallback): IListenerUID {
    listenerInc_++
    listeners_.push({ id: listenerInc_, callback })
    return listenerInc_
}

export function clearCustomerConnect(id: IListenerUID) {
    const index = listeners_.findIndex(listener => listener.id === id)
    if (index !== -1) {
        listeners_.splice(index, 1)
    }
}
